import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);
var currentYear = new Date().getFullYear();
export default function MeanAPEGraph({ summaryReports }) {
    var chart = {
        type: 'column'
    };
    var title = {
        text: "MAPE Comparison",
        align: "left",
        style: {
            fontSize: "14px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
       // format: '<strong>{key}</strong><br/>{series.name}: <strong>{y}</strong><br/>',
        formatter: function () {
            var tooltipText = `<strong>${this.x}</strong>`+ '<br/>';
            if (this.series.name === `${currentYear}-${currentYear + 1}`) {
              tooltipText += '<span style="color: #BB4A28;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y) + '%' + '</strong>';
            } else if (this.series.name === `${currentYear + 1}-${currentYear + 2}`) {
              tooltipText += '<span style="color: #005A70;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y) + '%' + '</strong>';
            }
            return tooltipText;
          },
        borderWidth: 1,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '14px',
        }
    };
    var legend = {
        enabled: true,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        column: {

            dataLabels: {
                enabled: false,
                style: {
                    textOutline: "none",
                },
            },
        },
        series:{
            events: {
                legendItemClick: function(e) {
                    return false;
                }
              }
        }
    };
    var series = [
        {
            name: `${currentYear}-${currentYear + 1}`,
            data: [summaryReports?.DemandAnalysis?.currentYearMapeValue?.REGULAR,summaryReports?.DemandAnalysis?.currentYearMapeValue?.MIDGRADE,summaryReports?.DemandAnalysis?.currentYearMapeValue?.PREMIUM],
            color: "#BB4A28",

        },
        {
            name: `${currentYear + 1}-${currentYear + 2}`,
            data: [summaryReports?.DemandAnalysis?.nextYearMapeValue?.REGULAR,summaryReports?.DemandAnalysis?.nextYearMapeValue?.MIDGRADE,summaryReports?.DemandAnalysis?.nextYearMapeValue?.PREMIUM],
            color: "#005A70",

        }
    ];
    var xAxis = {
        categories: ['Regular', 'Midgrade', 'Premium'],
        title: {
            text: "Gasoline Type",
        },
        lineColor: '#EFEFEC'
    }
    var yAxis = {
        allowDecimals: false,
        crosshair: true,
        min: 0,
        title: {
            text: 'MAPE (in %)'
        }
    }
    var accessibility = {
        enabled: true,
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.xAxis = xAxis;
    json.yAxis = yAxis;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        Highcharts.chart("MeanAPEGraph", json);
        //console.log(json);
    };
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div
            id="MeanAPEGraph"
            style={{ height: "340px" }}
            title={title.text}
            aria-label="Cost Analysis Graph"
            className="costAnalysis"
        ></div>
    );
}
